const rootArea = "/aliases";

export const aliasGlob = (baseArea: string) => ({
	self: `${baseArea}${rootArea}`,
	byCode: (configCode: string) => ({ 					
		read: `${baseArea}${rootArea}/${configCode}/read`
	})
});